import { Component, EventEmitter, Input, Output } from '@angular/core'
import { ApiService } from 'src/app/services/api.service'
import { SyncPhaseDto } from 'src/app/services/dtos'
import { UiService } from 'src/app/services/ui.service'
import { AccountService } from '../../services/account.service'
import { Application, ApplicationProviderService } from '../../services/application.service'
import { LaunchRestoreSettings, LaunchSyncDialogBase } from '../launch-sync-dialog-base'

import { AccessLevelService, AppPermission } from 'src/app/services/access-level.service'

export interface ConcludeRecoverySettings {
  restoreSettings: Array<LaunchRestoreSettings>
}

@Component({
  selector: 'conclude-recovery-dialog',
  templateUrl: './conclude-recovery-dialog.component.html',
  styleUrls: ['./conclude-recovery-dialog.component.scss'],
  standalone: false,
})
export class ConcludeRecoveryDialogComponent extends LaunchSyncDialogBase {
  @Input() currentlySyncing: boolean = false
  private recoveredApplicationIds = new Set<string>()

  constructor(
    applicationProviderService: ApplicationProviderService,
    accountService: AccountService,
    apiService: ApiService,
    uiService: UiService,
    accessLevelService: AccessLevelService
  ) {
    super(applicationProviderService, accountService, apiService, uiService, accessLevelService)
  }

  @Output() conclude = new EventEmitter<ConcludeRecoverySettings>()

  onConcludeClick() {
    this.conclude.emit({
      restoreSettings: this.selectedApplications.map((app) => {
        return {
          application: app,
        }
      }),
    })
  }

  protected applicationIsCandidate(application: Application) {
    // After concluding the recovery, the application syncPhase reverts to STANDBY before
    // the dialog is closed.  That causes some jumping around on the screen.
    // To fix this, we'll cache the IDs of applications that were ever in
    // FAILOVER within this dialog, and include them in the candidate
    // applications.
    if (application.syncPhase === SyncPhaseDto.FAILOVER) {
      this.recoveredApplicationIds.add(application.applicationId)
      return true
    }
    return this.recoveredApplicationIds.has(application.applicationId)
  }

  protected getRequiredPermission(): AppPermission {
    return AppPermission.MANAGE_RECOVERY
  }
}
